<template>
  <v-container>
    <v-row justify="center">
      <v-col
        md="6"
        sm="12"
        class="text-center my-5">
        <h2
          class="accent--text text-center my-3 display-3">
          Topics
        </h2>
        <p class="body-1 mt-6">
        Learn from our speakers in these tracks</p>
        <v-chip
          class="mr-3"
          color="success"
          outlined
        >
          Startup
        </v-chip>
        <v-chip
          class="ma-1"
          color="purple lighten-1"
          outlined
        >
          Small Business
        </v-chip>
        <!-- SCHEDULE -->
        <v-tabs
          v-model="tab"
          fixed-tabs
          background-color="accent"
          dark
          class="mt-5"
        >
          <v-tab>
            Thursday
          </v-tab>
          <v-tab>
            Friday
          </v-tab>

          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-row class="pt-1">
                  <v-col cols="3">
                    <strong class="headline font-weight-light">10am</strong>
                  </v-col>
                  <v-col class="text-left">
                    <strong class="title accent--text">Building a Bridge between Law and Tax</strong>
                    <div class="body-1">Gina Bongiovi &amp; Rebecca Warnick, CPA</div>
                  </v-col>
                </v-row>
                <v-row class="pt-1">
                  <v-col cols="3">
                    <strong class="headline font-weight-light">11am</strong>
                  </v-col>
                  <v-col class="text-left">
                    <strong class="title accent--text">Building a Software MVP (Minimum Viable Product)</strong>
                    <div class="body-1">Colin Loretz</div>
                  </v-col>
                </v-row>
                <v-row class="pt-1">
                  <v-col cols="3">
                    <strong class="headline font-weight-light">12pm</strong>
                  </v-col>
                  <v-col class="text-left">
                    <strong class="title accent--text">Setting Up Shop: Where will you office?</strong>
                    <div class="body-1">Dana Berggren</div>
                  </v-col>
                </v-row>
                <v-row class="pt-1">
                  <v-col cols="3">
                    <strong class="headline font-weight-light">1pm</strong>
                  </v-col>
                  <v-col class="text-left">
                    <strong class="title accent--text">How to Create your Storybrand</strong>
                    <div class="body-1">Evynn Mcfalls</div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-row class="pt-1">
                  <v-col cols="3">
                    <strong class="headline font-weight-light">10am</strong>
                  </v-col>
                  <v-col class="text-left">
                    <strong class="title accent--text">Elephant Spotting: How to Define the Right Metrics for Your Company Success</strong>
                    <div class="body-1">Heather Wilde</div>
                  </v-col>
                </v-row>
                <v-row class="pt-1">
                  <v-col cols="3">
                    <strong class="headline font-weight-light">11am</strong>
                  </v-col>
                  <v-col class="text-left">
                    <strong class="title accent--text">Growing Business at the International Innovation Center @ Vegas</strong>
                    <div class="body-1">Bill Arent</div>
                  </v-col>
                </v-row>
                <v-row class="pt-1">
                  <v-col cols="3">
                    <strong class="headline font-weight-light">12pm</strong>
                  </v-col>
                  <v-col class="text-left">
                    <strong class="title accent--text">Let's Talk about Money and Growth: Financing your Business</strong>
                    <div class="body-1">Monica Coburn</div>
                  </v-col>
                </v-row>
                <v-row class="pt-1">
                  <v-col cols="3">
                    <strong class="headline font-weight-light">1pm</strong>
                  </v-col>
                  <v-col class="text-left">
                    <strong class="title accent--text">Growing your Enterprise with Technology</strong>
                    <div class="body-1">Jimmy Jacobson</div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
      <v-col
        md="6"
        sm="12"
      >
        <v-timeline>
          <v-timeline-item
            v-for="(year, i) in years"
            :key="i"
            :color="year.color"
            right
          >
            <template v-slot:opposite>
              <span
                :class="`headline font-weight-bold ${year.color}--text`"
                v-text="year.year"
              ></span>
            </template>
            <div class="py-4">
              <h2 :class="`headline font-weight-light mb-4 ${year.color}--text`">{{year.topic}}</h2>
            </div>
          </v-timeline-item>
        </v-timeline>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {

  name: 'LandingTopics.vue',

  data: () => ({
    tab: null,
    years: [
      {
        color: 'success',
        year: '',
        side: 'left',
        topic: 'Ideas & Product',
      },
      {
        color: 'success',
        year: 'Day 1',
        side: 'left',
        topic: 'Regulatory & Compliance',
      },
      {
        color: 'success',
        year: '',
        side: 'left',
        topic: 'Operations',
      },
      {
        color: 'secondary',
        year: '',
        side: 'right',
        topic: 'Marketing & Distribution',
      },
      {
        color: 'secondary',
        year: 'Day 2',
        side: 'right',
        topic: 'Sales',
      },
      {
        color: 'secondary',
        year: '',
        side: 'right',
        topic: 'Growth',
      },
    ],
  }),
};
</script>

<style lang="css" scoped>
</style>
